import React from 'react';
import { styled } from '@compiled/react';

import CheckIcon from '@atlaskit/icon/core/check-mark';
import { token } from '@atlaskit/tokens';

import type { LargeColorCircleProps } from './types.ts';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LargeCircleWrapper = styled.div({
	margin: `${token('space.0')} ${token('space.100')}`,
	cursor: 'pointer',
});

type CircleProps = {
	color: string;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Circle = styled.div<CircleProps>({
	width: '22px',
	height: '22px',
	borderRadius: token('radius.full'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	background: ({ color }) => color,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CheckIconWrapper = styled.div({
	position: 'absolute',
	height: '22px',
	width: '22px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	marginTop: token('space.0'),
});

export const LargeColorCircle = ({
	color,
	selectedColor,
	setSelectedColor,
}: LargeColorCircleProps) => {
	let isSelected = false;

	if (color === selectedColor) {
		isSelected = true;
	}

	return (
		<LargeCircleWrapper
			data-testid="large-circle-wrapper"
			onClick={() => {
				setSelectedColor(color);
			}}
		>
			{isSelected ? (
				<CheckIconWrapper>
					<CheckIcon label="check-icon" color={token('color.icon.inverse')} testId="check-icon" />
				</CheckIconWrapper>
			) : null}
			<Circle color={color} data-testid="large-color-circle" />
		</LargeCircleWrapper>
	);
};
